export enum MyStrategyType {
    Deployed = 'Deployed',
    AiRecommended = 'AiRecommended',
    Originals = 'Originals',
    Created = 'Created',
    Saved = 'Saved',
    Shared = 'Shared',
    Subscribed = 'Subscribed',
}

export enum cacheMapTypes {
    Deployed = 'Deployed',
    Created = 'Created',
    Subscribed = 'Subscribed',
    Shared = 'Shared',
    Saved = 'Saved',
    Originals = 'Originals'
}

export enum MyButtonType {
    Deploy = 'Deploy',
    Subscribe = 'Subscribe',
    Undeploy = 'Undeploy',
    Locked = 'Locked'
}

export enum ButtonStateType {
    SquareOff = 'Square Off',
    Stopped = 'Stopped',
    ErrorState = 'ErrorState',
    CancelAutoSquareOff = 'Cancel Auto Square Off',
    Accept = 'Accept'
}

export enum StrategyType {
    bookmarked = 'bookmarked',
    subscribed = 'subscribed',
    deployed = 'deployed'
}



export const viewedPortfolios = "viewedPortfolios";